var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.288 30.1209C15.3221 30.1209 12.9092 32.5338 12.9092 35.4997C12.9092 38.4656 15.3221 40.8785 18.288 40.8785C21.2538 40.8785 23.6668 38.4656 23.6668 35.4997C23.6668 32.5338 21.2538 30.1209 18.288 30.1209Z",
    fill: "#B82428"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4999 30.1209C32.534 30.1209 30.1211 32.5338 30.1211 35.4997C30.1211 38.4656 32.534 40.8785 35.4999 40.8785C38.4657 40.8785 40.8787 38.4656 40.8787 35.4997C40.8787 32.5338 38.4657 30.1209 35.4999 30.1209Z",
    fill: "#B82428"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.712 30.1209C49.7462 30.1209 47.3333 32.5338 47.3333 35.4997C47.3333 38.4656 49.7462 40.8785 52.712 40.8785C55.6779 40.8785 58.0908 38.4656 58.0908 35.4997C58.0908 32.5338 55.6779 30.1209 52.712 30.1209Z",
    fill: "#B82428"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 -0.000289917C15.9253 -0.000289917 0 15.925 0 35.4997C0 55.0744 15.9253 70.9997 35.5 70.9997C55.0747 70.9997 71 55.0744 71 35.4997C71 15.925 55.0747 -0.000289917 35.5 -0.000289917ZM35.5 64.5452C19.4843 64.5452 6.45455 51.5154 6.45455 35.4997C6.45455 19.484 19.4843 6.45426 35.5 6.45426C51.5157 6.45426 64.5455 19.484 64.5455 35.4997C64.5455 51.5154 51.5157 64.5452 35.5 64.5452Z",
    fill: "#B82428"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.dc1fbff5fe5fb3734c50df54d2697390.svg";
export { ForwardRef as ReactComponent };